import { getTalentMarketPlaceViewContactDetails } from "../api/Candidate.api";
import { getErrorMessage } from "../../../../utils/errorMessages";

const getViewContactErrorMessage = (error: any) => {
  return getErrorMessage(
    error,
    "Unable to unlock contact details. Please try again.",
  );
};

export const useCandidateViewModel = () => {
  const handleTalentMarketPlaceViewContact = async (
    candidateId: string,
    onSuccess?: (data: any) => void,
    onError?: (message: string) => void,
  ) => {
    try {
      const payload = { access_type: "marketplace" };
      const response = await getTalentMarketPlaceViewContactDetails(
        candidateId,
        payload,
      );
      const contactDetails = response.data;
      if (contactDetails?.success === false) {
        onError?.(
          contactDetails?.message ||
            "Unable to unlock contact details. Please try again.",
        );
        return;
      }
      onSuccess?.(contactDetails);
    } catch (error: any) {
      console.error("Error fetching contact details:", error);
      onError?.(getViewContactErrorMessage(error));
    }
  };
  
  return {
    handleTalentMarketPlaceViewContact,
  };
};
